import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import MultiSelect from "../../components/select/MultiSelect";
import { Select } from "../../components/select/Select";
import type { SelectedTag } from "../../components/tagSelect/TagSelect";
import TagSelect from "../../components/tagSelect/TagSelect";
import AgentMultiSelect from "../../sharedComponents/agentSelect/AgentMultiSelect";
import { CUSTOMER_STATUS_VALUES } from "../customerStatus";
import type { CustomerStatus } from "../customersApi";
import { useCustomerTagsByCategory } from "../useCustomerTagsByCategory";

export interface CustomerFilters {
  readonly query: string;
  readonly statuses: CustomerStatus[];
  readonly travelPayStatus: CustomerStatus | undefined;
  readonly accountManagerIds: string[];
  readonly marketSegment: SelectedTag[];
}

interface Props {
  readonly filters: CustomerFilters;
  readonly onChange: (filters: Partial<CustomerFilters>) => void;
  readonly onClear: () => void;
}

const CustomerSearch: FC<Props> = ({ filters, onChange, onClear }) => {
  const customerTagsByCategory = useCustomerTagsByCategory();

  const statusValues = CUSTOMER_STATUS_VALUES.map((value) => ({ value }));
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
      }}
    >
      <SearchIcon />
      <Box
        sx={{
          flexBasis: 0,
          flexGrow: 5,
        }}
      >
        <TextField
          fullWidth
          value={filters.query}
          label="Szukaj"
          onChange={(e) => onChange({ query: e.target.value ?? "" })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: 0,
          flexGrow: 2,
        }}
      >
        <MultiSelect
          label="Status"
          fullWidth
          selected={filters.statuses}
          values={statusValues}
          onSelect={(v) => onChange({ statuses: v as CustomerStatus[] })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: 0,
          flexGrow: 2,
        }}
      >
        <Select
          label="Status TravelPay"
          fullWidth
          value={filters.travelPayStatus ?? ""}
          values={statusValues}
          onSelect={(v) => onChange({ travelPayStatus: v as CustomerStatus })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: 0,
          flexGrow: 3,
        }}
      >
        <TagSelect
          label="Segment rynku"
          tags={filters.marketSegment}
          availableTags={customerTagsByCategory}
          maxVisibleTags={2}
          onChange={(marketSegment) => onChange({ marketSegment })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: 0,
          flexGrow: 3,
        }}
      >
        <AgentMultiSelect
          label="Opiekun"
          agentIds={filters.accountManagerIds}
          onChange={(accountManagerIds) => onChange({ accountManagerIds })}
        />
      </Box>
      <IconButton color="inherit" onClick={onClear}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default CustomerSearch;
